import { render, staticRenderFns } from "./databaseDashboard.vue?vue&type=template&id=55f8deb4&"
import script from "./databaseDashboard.vue?vue&type=script&lang=js&"
export * from "./databaseDashboard.vue?vue&type=script&lang=js&"
import style0 from "./databaseDashboard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports